export default __webpack_public_path__ + "static/media/investment_male@2x.46f5f52c.png";